import { useEffect } from "react";
import { PlanId } from "components/common/boundary/PlanId";
import { useSearchId } from "hooks/search";
import { useTenant } from "hooks/settings";
import { useDeployProcess } from "hooks/useDeployProcess";
import { SearchType } from "src/store/api/generatedApi";
import { isPurchasingSearchType } from "src/utils/isPurchasingSearchType";
import { Modal as EditAndSendPlanModal } from "../editAndSendPlan/Modal";
import { Modal as MessagePlanModal } from "../messagePlan/modal";
import { SyncAndSMSPlanModal } from "./syncAndSMSPlanModal";
import { PurchasingPlanDeployModal } from "../purchasingPlan/PurchasingPlanDeployModal";

interface Props {
  open: boolean;
  handleClose: () => void;
  planId: PlanId;
  searchType: SearchType | null;
}

export const DeployModal = ({
  open,
  handleClose,
  planId,
  searchType,
}: Props) => {
  const deployProcess = useDeployProcess();
  const searchId = useSearchId();
  const tenantName = useTenant();

  useEffect(() => {
    if (deployProcess === "edit_and_send" && open && searchId !== null) {
      const url = `/${tenantName}/deploy-plan?plan=${planId}&search=${searchId}`;
      window.open(url, "_blank");
      handleClose();
    }
  }, [deployProcess, open, searchId, tenantName, planId, handleClose]);

  if (isPurchasingSearchType(searchType)) {
    return <PurchasingPlanDeployModal open={open} doClose={handleClose} />;
  }

  switch (deployProcess) {
    case "edit_and_send": {
      return <EditAndSendPlanModal open={open} doClose={handleClose} />;
    }

    case "sync_and_sms":
    case "edit_sync_and_sms": {
      return <SyncAndSMSPlanModal open={open} doClose={handleClose} />;
    }

    case "message": {
      return (
        <MessagePlanModal open={open} doClose={handleClose} planId={planId} />
      );
    }

    case "none":
    default: {
      return null;
    }
  }
};
